import { FincasPlataformaService } from "../../../shared/generated/grpc/plataforma_terceros_fincas_pb";
import { FincaMapaResponse } from "../../../shared/response/terceros/FincaMapaResponse";
import { grpcCall, grpcClient } from "../../../shared/services/grpc/grpcCall";
import { wkbToPolygon } from "../../../shared/utils/wkbUtils";

/** Fincas para el mapa global (`FincasPlataformaService.ListFincasMapa`, gRPC). Sin caché: el mapa pide
 *  la foto actual cada vez que se abre. Incluye las fincas sin cliente; un promotor recibe solo las de su
 *  cartera (lo filtra el Server). */
export class FincaMapaService {
  static readonly instance = new FincaMapaService();
  private constructor() {}

  /** Todas las fincas dibujables, con su ubicación, AOI y dueños (o, si no tiene, su último nombre). */
  async getAll(): Promise<FincaMapaResponse[]> {
    const r = await grpcCall(() => grpcClient(FincasPlataformaService).listFincasMapa({}));
    return r.items.map((f) => ({
      id: f.id,
      latitud: f.latitud,
      longitud: f.longitud,
      aoi: f.aoiWkb && f.aoiWkb.length > 0 ? aoiSeguro(f.aoiWkb) : null,
      duenos: f.duenos.map((d) => ({ clienteId: d.clienteId, clienteNombre: d.clienteNombre, nombreFinca: d.nombreFinca })),
      nombreUltimo: f.nombreUltimo ?? null,
    }));
  }
}

/** WKB → polígono; si el AOI simplificado llega en otra forma (p. ej. colapsó), se dibuja solo el punto. */
function aoiSeguro(wkb: Uint8Array): FincaMapaResponse["aoi"] {
  try {
    return wkbToPolygon(wkb);
  } catch {
    return null;
  }
}
